import { injectable, inject } from 'inversify';
import type { ITenantRepository } from '@/domain/repositories/ITenantRepository';
import { Tenant } from '@/domain/entities/Tenant';
import { TYPES } from '@/di/tokens';

@injectable()
export class GetTenantAction {
  constructor(
    @inject(TYPES.ITenantRepository) private tenantRepository: ITenantRepository
  ) {}

  async execute(id: number | string): Promise<Tenant> {
    return await this.tenantRepository.getById(id);
  }
}
